export const caseStudyContent = {
  stamp: "Case Study",
  title: "Real Field Results",
  metrics: [
    {
      figure: "+6",
      subtitle: "Extra Inspections / Week",
      detail: "Qualified and booked on the calendar without human intervention.",
    },
    {
      figure: "9 Seconds",
      subtitle: "Avg Response Time",
      detail: "24/7 instant engagement (vs. 4h 12m industry average delay).",
    },
    {
      figure: "100%",
      subtitle: "After-Hours Capture",
      detail: "Zero leads lost on nights, weekends, or while crews are on roofs.",
    },
  ],
  quote:
    "\"We used to miss a lot of our leads simply because we were driving or on job sites. Now, 100% of inbound requests are qualified and booked instantly, day or night. It added ~6 signed estimates a week to our calendar.\"",
  attribution: {
    name: "Jovan Dedovic",
    role: "Co-founder of ozexteriorsroofinggroup.com",
  },
}
